import React, {
    useState,
    useContext,
    useEffect,
    useRef,
} from "react";

const AddButton = ({ GlobalAppContext }) => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [expandedParents, setExpandedParents] = useState([]);
    const menuRef = useRef(null);
    const buttonRef = useRef(null);

    const categoriesUrl = GlobalAppContext.srCategoriesUrl;
    const [menuOptions, setMenuOptions] = useState([]);

    const srMainUrl = "/systematic-reviews/?area=[AREA]&section=[ALIAS]"

    let hasAllowance = LimitNumberOfSurveillances == 0 || LimitNumberOfSurveillances > NumberOfSurveillances;

    useEffect(() => {

        fetch(categoriesUrl)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let options = [];
                let parentCategories = [];

                // Are we seeing the SRs from a project? If so show all types to add
                if (GlobalAppContext.srProjectIdFilter) {
                    parentCategories = ["Clinical", "Regulatory", "Standards", "Market", "PMS Vigilance"];
                }
                else {
                    if (GlobalAppContext.selectedFilterSystematicReviewsArea == 0)
                        parentCategories = ["Clinical", "Regulatory", "Standards", "Market", "PMS Vigilance"];

                    if (GlobalAppContext.selectedFilterSystematicReviewsArea == 1)
                        parentCategories = ["Clinical"];

                    if (GlobalAppContext.selectedFilterSystematicReviewsArea == 2)
                        parentCategories = ["Regulatory", "Standards"];

                    if (GlobalAppContext.selectedFilterSystematicReviewsArea == 3)
                        parentCategories = ["Market"];

                    if (GlobalAppContext.selectedFilterSystematicReviewsArea == 4)
                        parentCategories = ["PMS Vigilance"];
                }


                data.filter(item => parentCategories.includes(item.ParentCategory)).map((item, index) => {

                    let newItem = {
                        id: "parent" + index,
                        label: item.ParentCategory,
                        children: []
                    };

                    item.ChildCategories.map((child, index) => {
                        newItem.children.push({
                            id: "child" + index,
                            label: child.ItemName,
                            url: srMainUrl.replace("[ALIAS]", child.Alias).replace("[AREA]", GlobalAppContext.selectedFilterSystematicReviewsArea),
                            alias: child.Alias
                        });
                    });

                    options.push(newItem);

                });

                setMenuOptions(options);


            })
            .catch((error) => {
            });


    }, [])






    //const menuOptions = [
    //    {
    //        id: 'parent1',
    //        label: 'Parent Option 1',
    //        children: [
    //            { id: 'child1', label: 'Child 1', url: '/path/child1' },
    //            { id: 'child2', label: 'Child 2', url: '/path/child2' },
    //        ],
    //    },
    //    {
    //        id: 'parent2',
    //        label: 'Parent Option 2',
    //        children: [
    //            { id: 'child3', label: 'Child 3', url: '/path/child3' },
    //            { id: 'child4', label: 'Child 4', url: '/path/child4' },
    //        ],
    //    },
    //    {
    //        id: 'single',
    //        label: 'Single Option',
    //        url: '/path/single',
    //    },
    //];



    const handleMainCreateButton = () => {

        // If there is a section preselected (possibly initialized in the url parameter) so show the create form for that type immediately
        if (GlobalAppContext.selectedFilterSystematicReviewsSection)
            handleChildClick(GlobalAppContext.selectedFilterSystematicReviewsSection);
        else
            toggleMenu();

    }




    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        if (!isMenuOpen) {
            setExpandedParents([]);
        }
    };

    const toggleParent = (parentId) => {
        setExpandedParents(prev => 
            prev.includes(parentId) 
                ? prev.filter(id => id !== parentId) 
                : [...prev, parentId]
        );
    };

    const handleChildClick = (srType) => {
        
        setIsMenuOpen(false);

        GlobalAppContext.setSelectedSystematicReviewsTypeAdd(srType);

        GlobalAppContext.showAddItemPopup(true);

    };

    const handleClickOutside = (event) => {

        if (menuRef.current && !menuRef.current.contains(event.target)) {
            if (buttonRef.current && !buttonRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        }
    };

    useEffect(() => {

        if (isMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMenuOpen]);

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>

            {hasAllowance ? <>
                <span ref={buttonRef} onClick={handleMainCreateButton}>
                    <span className="action-button add-task-button" title="Create a Systematic Review">
                        <i className="fas fa-plus-circle g-mr-5"></i> Add {GlobalAppContext.singleItemTitle}
                    </span>
                </span>

            </> : <>
                <span ref={buttonRef}>
                        <span className="action-button add-task-button" style={{cursor: "help", backgroundColor: "#d8d8d8"}} title="Systematic Reviews number limit reached. You can't create more Systematic Reviews with the current plan.">
                            <i className="fas fa-plus-circle g-mr-5"></i> Add {GlobalAppContext.singleItemTitle}
                    </span>
                </span>

            </>}




            {isMenuOpen && (
                <div 
                    ref={menuRef}
                    style={{
                        position: 'absolute',
                        top: '100%',
                        right: '0px',
                        backgroundColor: 'white',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                        zIndex: 1000,
                        width: '250px',
                        maxWidth: '350px',
                        maxHeight: '300px',
                        overflowY: 'auto',
                    }}
                >
                    {menuOptions.map((option) => (
                        <div key={option.id}>
                            {option.children ? (
                                <>
                                    <div
                                        style={{
                                            padding: '8px 12px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            fontWeight: 'bold',
                                            borderBottom: '1px solid #eee',
                                        }}
                                        onClick={() => toggleParent(option.id)}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                    >
                                        <span style={{marginRight: '10px'}}>
                                            {expandedParents.includes(option.id) ? <i className="fas fa-angle-down hover-menu-opened-indicator"></i> : <i className="fas fa-angle-right hover-menu-opened-indicator"></i>}
                                        </span>
                                        <span style={{flex: 1, textAlign: 'left'}}>{option.label}</span>
                                    </div>
                                    {expandedParents.includes(option.id) && (
                                        <div style={{ paddingLeft: '16px' }}>
                                            {option.children.map((child) => (
                                                <div
                                                    key={child.id}
                                                    style={{
                                                        padding: '8px 12px',
                                                        cursor: 'pointer',
                                                        textAlign: 'left',
                                                        borderRadius: '5px',
                                                    }}
                                                    className="ellipsis"
                                                    onClick={() => handleChildClick(child.alias)}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                >
                                                    {child.label}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div
                                    style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => handleChildClick(option.url)}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'red'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                >
                                    {option.label}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );

}


export default AddButton;